import firebase from "firebase/compat/app";

const removeChallengeGroup = async function(competition_id, group_id) {
  let db = firebase.firestore();
  if ( competition_id && group_id ) {
    
    //remove users
    // await db
    //   .collection("wellness_competition")
    //   .doc(competition_id)
    //   .collection("users")
    //   .where("groupId", "==", group_id)
    //   .delete();

    //remove group
    await db
      .collection("wellness_competition")
      .doc(competition_id)
      .collection("groups")
      .doc(group_id)
      .delete();
  }
};

export default removeChallengeGroup;
